import React, { createContext, useContext, useState } from "react";

const EmpresaContext = createContext();

export function EmpresaProvider({ children }) {
  const [empresa, setEmpresaState] = useState(() => {
    try {
      return localStorage.getItem("empresaActual") || "sushiito";
    } catch (e) {
      return "sushiito";
    }
  });

  function setEmpresa(nuevaEmpresa) {
    setEmpresaState(nuevaEmpresa);
    try {
      localStorage.setItem("empresaActual", nuevaEmpresa);
    } catch (e) {}
  }

  return (
    <EmpresaContext.Provider value={{ empresa, setEmpresa }}>
      {children}
    </EmpresaContext.Provider>
  );
}

export function useEmpresa() {
  return useContext(EmpresaContext);
}
